var _defs, _path, _path2, _ellipse, _path3, _path4, _path5, _circle, _circle2, _polyline, _path6, _polygon, _line, _line2, _line3, _line4, _line5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncognitoSun01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffae42;}.cls-2{fill:#ffc900;}.cls-3{fill:url(#radial-gradient);}.cls-4{fill:url(#radial-gradient-2);}.cls-5,.cls-7{fill:none;stroke:#000;stroke-miterlimit:10;}.cls-5{stroke-width:12px;}.cls-6{fill:#fff;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 176.47,
    cy: 109.05,
    r: 262.14,
    gradientTransform: "matrix(0.34, 0, 0, -0.34, 116.09, 235.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ffde02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ffd909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ffd014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#ffc325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#ffb33b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffae42"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 749.46,
    cy: 11.06,
    r: 262.14,
    gradientTransform: "matrix(0.34, 0, 0, -0.34, -77.71, 202.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffae42"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "incognito-sun") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.33,336.37c-2.44-.09-3.93-4.14-6-9.74-3-8.1-7.1-19.24-17.74-28.36-11.18-9.59-24.19-12.27-30.94-13a54.49,54.49,0,0,0-5.85-.34c-14.9,0-27.47,6.22-35.79,10.33-4,2-7.52,3.71-9.32,3.71-.53,0-.66-.15-.71-.22-.67-.81,1.75-4.48,3.7-7.43,4.39-6.63,11-16.66,12.2-30.41.18-2.08,1.42-20.75-9.85-36.33-9.58-13.26-24-18.42-33.54-21.83-5.06-1.81-9.85-3.52-9.75-5.2s4.66-2.72,9.5-3.92c9-2.23,22.76-5.61,33.26-17,3.2-3.47,13.6-16.05,13.14-32.47-.47-16.6-12-29.07-19.61-37.32-2.45-2.66-6.16-6.68-6-7.77a1.18,1.18,0,0,1,.42,0c1.66,0,5.09,1.47,9.08,3.18,8.6,3.68,21.59,9.24,36.6,9.24a58.52,58.52,0,0,0,10.48-.94A60.44,60.44,0,0,0,146.33,96c13.83-12.66,17.9-29.44,20.58-40.55,1.37-5.64,2.67-11,4.43-11h0c1.85,0,3.62,5.65,5.49,11.61,3.66,11.68,9.19,29.32,24.44,40.77,13.77,10.32,29.94,11.44,36.27,11.44h.56c16.91-.17,29.85-7.47,38.41-12.29,3.66-2.06,6.8-3.84,8.31-3.84.31,0,.38.08.41.11.18.2.15,1-.54,2.44a64.32,64.32,0,0,1-4.11,6.87c-6,9.34-15.13,23.46-15.05,41.65,0,7.37,1.51,21.46,11,33,10.53,12.86,26,16.49,36.27,18.91A57.32,57.32,0,0,1,320,197c1.77.67,1.84,1.15,1.84,1.15s-.07.4-1.59,1a53.3,53.3,0,0,1-6.47,1.79c-8.6,2.05-21.6,5.16-32.38,15.34-.7.68-17.24,16.55-17.44,39.59-.13,13.84,5.82,24.83,9.76,32.1,2.23,4.1,4.33,8,3.31,9a1.08,1.08,0,0,1-.86.29c-1.66,0-4.65-1.55-8.13-3.34-7.13-3.67-17.91-9.23-31.6-9.23h-.57c-18.26.22-31.79,9.87-35.5,12.83-11.52,9.15-16.49,20.59-20.12,28.95-2.4,5.53-4.3,9.89-6.75,9.89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.42,46.07a10.55,10.55,0,0,1,1.4,2.6c.83,2,1.67,4.66,2.64,7.77,3.72,11.86,9.34,29.78,25,41.52,14.12,10.59,30.67,11.74,37.14,11.74h.6c17.3-.17,30.43-7.58,39.12-12.49,2-1.15,4.44-2.5,6.06-3.19-.14.3-.33.65-.54,1.06-.84,1.53-2,3.38-3.43,5.55-6.13,9.5-15.38,23.85-15.31,42.49,0,7.58,1.56,22.06,11.34,34,10.85,13.25,26.64,17,37.08,19.41,2.05.48,4.42,1,6.09,1.57-1.47.46-3.46.93-5.19,1.35-8.76,2.09-22,5.25-33.06,15.72-.72.67-17.71,17-17.92,40.68-.13,14.25,5.94,25.44,9.95,32.84,1.12,2.05,2.08,3.83,2.7,5.28a10.23,10.23,0,0,1,.62,1.76c-1.48-.27-4.29-1.72-7-3.12-7.24-3.76-18.22-9.41-32.27-9.41h-.63c-18.72.23-32.6,10.13-36.41,13.14-11.8,9.38-16.86,21-20.56,29.54-1.83,4.21-3.9,9-5.38,9h0c-1.45-.06-3.15-4.68-4.66-8.78-3.06-8.27-7.24-19.6-18.17-29-11.49-9.85-24.83-12.6-31.76-13.37a57.68,57.68,0,0,0-6-.34c-15.24,0-28,6.31-36.44,10.47a59.41,59.41,0,0,1-7.57,3.38,57.61,57.61,0,0,1,3.14-5.1c4.47-6.75,11.23-17,12.45-31.13a59.06,59.06,0,0,0-.61-13.35,54.81,54.81,0,0,0-9.53-24C64.36,210,49.69,204.76,40,201.28c-2.56-.91-4.78-1.71-6.44-2.48a10.27,10.27,0,0,1-2.06-1.18,9.65,9.65,0,0,1,1.95-.86c1.61-.56,3.72-1.08,6.16-1.69,9.24-2.28,23.22-5.74,34-17.44,3.3-3.58,14-16.55,13.55-33.56-.49-17.17-12.24-29.89-20-38.31-1.4-1.51-3-3.24-4.12-4.63,1.67.6,3.85,1.52,6,2.43,8.71,3.71,21.88,9.36,37.19,9.36a60.41,60.41,0,0,0,10.74-1,62.31,62.31,0,0,0,30.43-14.91c14.17-13,18.29-30,21-41.32.7-2.89,1.31-5.4,1.95-7.27a10.43,10.43,0,0,1,1.1-2.43m0-3.23h-.1c-7.35.34-3.72,31.63-25.95,52A59.79,59.79,0,0,1,116.39,109a57.54,57.54,0,0,1-10.22.91c-22.22,0-39.89-12.42-45.69-12.42a1.85,1.85,0,0,0-1.66.7c-3.25,4.75,24.62,20.68,25.32,46,.47,16.71-11,29.52-12.73,31.39-17.11,18.59-42.79,15.2-43.19,21.9-.41,7,28,6.51,43.59,28,11,15.26,9.72,33.48,9.56,35.31-1.94,22.58-19,34.84-15.55,39a2.27,2.27,0,0,0,1.86.76c6.19,0,22.87-14,45.1-14a51.84,51.84,0,0,1,5.7.31c4.58.5,18.34,2.54,30.14,12.67,18.42,15.8,16.83,38.15,24.65,38.45h.16c7.86,0,7.87-23.34,27.79-39.16,2-1.58,15.82-12.26,34.6-12.49h.6c20.42,0,33.94,12.57,39.73,12.57a2.57,2.57,0,0,0,1.92-.75c4.29-4.46-12.85-19-12.64-42.2.2-22.19,16.12-37.69,17-38.49,17.34-16.39,40.9-14,40.92-19.24,0-5.83-29.22-3-45.57-23-10.56-12.88-10.65-29-10.65-32.07-.13-28.7,23.48-47.45,19.3-52a2,2,0,0,0-1.51-.59c-5.79,0-22.11,15.86-46.73,16.12h-.57c-5.27,0-21.49-.74-35.36-11.14C177.87,77.23,179,42.83,171.39,42.83Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 175.77,
    cy: 198.3,
    rx: 88.66,
    ry: 89.97
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.77,109.68c48.09.06,87,39.67,87,88.47s-39.09,88.3-87.18,88.24-87-39.67-87-88.47a88.39,88.39,0,0,1,53.19-81.28,85.68,85.68,0,0,1,34-7m0-1.35c-49,0-88.66,40.28-88.66,90s39.7,90,88.66,90,88.66-40.29,88.66-90S224.73,108.33,175.77,108.33Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M230.06,44S204,49,172.41,55.31a1.11,1.11,0,0,1-.27.12c-.91.22-1.68.3-2.58.45C127.66,64.32,77.43,75,66,79.77L23.52,172s16.79-20.42,95.39-35c1.45-.27,67.55,3.57,71,3s59.93-22.85,61-23c64-8.91,74.45-3.79,75.57-3.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.7,48.41a30.77,30.77,0,0,1,4.93-1L221,36.66,204.76,12.11,108.59,44.43,82.07,38.61,75,70.45,167.72,49A11.66,11.66,0,0,1,169.7,48.41Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124.73,
    cy: 163.6,
    r: 37.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 158.4,
    r: 37.4
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "129.92 168.79 173.56 158.4 225.35 161.33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M167,52.24a18,18,0,0,1,5.14-1.18c.87-.14,4.07-1.43,4.7-.88l.66-2.51c-1.48.3-2.08-.55-3.37-.65s-2.37.56-3.49.9c-2.76.83-5,1.71-6.81,4a1.51,1.51,0,0,0,1.3,2.26,71.49,71.49,0,0,0,14.31-2.28l-1.84-1.84-1,1.17A1.52,1.52,0,0,0,177,54l.57.24v-2.9c-4.55.66-9.81.73-14.06,2.54-1.34.57-.69,3,.76,2.8,3.74-.47,7.44-1.09,11.12-1.89,1.89-.41,1.09-3.3-.8-2.9q-5.12,1.13-10.32,1.79l.75,2.79c3.93-1.67,9.15-1.63,13.34-2.23,1.66-.24,1.17-2.41,0-2.9l-.56-.23.36,2.74a5.3,5.3,0,0,0,2.39-3c.42-1.1-.82-2.11-1.84-1.84a68.06,68.06,0,0,1-13.52,2.17l1.29,2.26c1.13-1.47,2.89-2,4.57-2.53a10.77,10.77,0,0,0,1.78-.54c.52-.26.9-.41.8-.42.64.1,1.22.72,2,.82a8.1,8.1,0,0,0,2.77-.24,1.5,1.5,0,0,0,.66-2.5c-1.72-1.5-3.24-.92-5.28-.36-2.77.76-5.54.71-8.2,1.95-1.74.81-.22,3.4,1.52,2.59Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "324.38 145 249.41 310.5 100.4 310.5 32.91 169.9 181.41 196.5 324.38 145"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.91,
    y1: 169.9,
    x2: 100.4,
    y2: 310.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 249.41,
    y1: 310.5,
    x2: 100.4,
    y2: 310.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 249.41,
    y1: 310.5,
    x2: 324.38,
    y2: 145
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 181.41,
    y1: 196.5,
    x2: 324.38,
    y2: 145
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.91,
    y1: 169.9,
    x2: 181.41,
    y2: 196.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncognitoSun01);
export default __webpack_public_path__ + "static/media/incognito-sun-01.61b506ea92d70fda7d3efc1aa8c9b404.svg";
export { ForwardRef as ReactComponent };